import { CompanyDto } from './company-dto.model';
import { ProjectCompanyDistanceDto } from './project-company-distance-dto.model';


export class ProjectDto implements IProjectDto {
    id!: number;
    projectName!: string | undefined;
    companyId!: number;
    company!: CompanyDto;
    address!: string | undefined;
    longitude!: number | undefined;
    latitude!: number | undefined;
    orderKey!: string | undefined;
    scope!: string | undefined;
    isActive!: boolean;
    projectCompanyDistance!: ProjectCompanyDistanceDto[] | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectName = _data["projectName"];
            this.companyId = _data["companyId"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.address = _data["address"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.orderKey = _data["orderKey"];
            this.scope = _data["scope"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["projectCompanyDistance"])) {
                this.projectCompanyDistance = [] as any;
                for (let item of _data["projectCompanyDistance"])
                    this.projectCompanyDistance!.push(ProjectCompanyDistanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectName"] = this.projectName;
        data["companyId"] = this.companyId;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["address"] = this.address;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["orderKey"] = this.orderKey;
        data["scope"] = this.scope;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.projectCompanyDistance)) {
            data["projectCompanyDistance"] = [];
            for (let item of this.projectCompanyDistance)
                data["projectCompanyDistance"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IProjectDto {
    id: number;
    projectName: string | undefined;
    companyId: number;
    company: CompanyDto;
    address: string | undefined;
    longitude: number | undefined;
    latitude: number | undefined;
    orderKey: string | undefined;
    scope: string | undefined;
    isActive: boolean;
    projectCompanyDistance: ProjectCompanyDistanceDto[] | undefined;
}

